export default function SciPy_Home() {
  return (
    <div>
      <h1>SciPy Home</h1>
    </div>
  );
}
